module.exports = __webpack_public_path__ + "img/imweb_design_2.e581848d.png";